var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Team extends Component {
    constructor() {
        super('Team', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.module-team__persons').length > 0) {
                // Randomize the order of team members
                const teamMembers = Array.from(document.querySelectorAll('.module-team__person'));
                const shuffledMembers = teamMembers.sort(() => Math.random() - 0.5);
                const container = $('.module-team__persons').empty();
                if (container) {
                    shuffledMembers.forEach(member => container.append($(member)));
                }
                // Move 3 first team members to the featured section
                const featuredContainer = $('.module-team__persons-featured');
                if (featuredContainer) {
                    const firstThreeMembers = shuffledMembers.slice(0, 3);
                    firstThreeMembers.forEach(member => featuredContainer.append($(member)));
                }
                // If less than 4 team members, hide the collapse button
                if (shuffledMembers.length <= 3) {
                    $('.btn-toggle-collapse ').remove();
                }
            }
            this.success();
        });
    }
}
